export { default } from './ComparisonModal';
